import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "page-hero" }
const _hoisted_2 = { class: "flex flex-col gap-2 md:flex-row md:items-center md:justify-between" }
const _hoisted_3 = { class: "min-w-0 text-left" }
const _hoisted_4 = { class: "text-[9px] font-bold uppercase tracking-wide text-blue-100/95" }
const _hoisted_5 = { class: "mt-0.5 text-[15px] font-black leading-tight md:text-base" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1 max-w-2xl text-[10px] font-semibold leading-4 text-white/90 md:text-[11px]"
}
const _hoisted_7 = {
  key: 0,
  class: "w-full min-w-0 sm:w-auto sm:shrink-0 [&>*]:w-full sm:[&>*]:w-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString($props.eyebrow), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString($props.title), 1),
        ($props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($props.description), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}